import { RateCardsService } from "@common/client"
import { makeAxiosMutation, makeQuery } from "./utils"

const RATE_CARD_PAGE_SIZE = 500

export const rateCardsBaseKey = ["rate-cards"] as const

export const rateCardKey = (rateCardId: string) =>
  [...rateCardsBaseKey, "detail", rateCardId] as const

export const rateCardsKey = (search: string, deleted: boolean) =>
  [...rateCardsBaseKey, "list", { search, deleted }] as const

export const rateCardsQuery = makeQuery({
  serviceCall: ({ search, deleted }: { search: string; deleted: boolean }) =>
    RateCardsService.listRateCards({
      search: search || null,
      deleted,
      limit: RATE_CARD_PAGE_SIZE,
    }),
  queryKey: ({ search, deleted }) => rateCardsKey(search, deleted),
})

export const rateCardQuery = makeQuery({
  serviceCall: (params: Parameters<typeof RateCardsService.get>[0]) =>
    RateCardsService.get({ ...params, include_archived: true }),
  queryKey: ({ rate_card_id }) => rateCardKey(rate_card_id),
})

export const useCreateRateCardMutation = makeAxiosMutation({
  serviceCall: RateCardsService.create,
  invalidates: () => [rateCardsBaseKey],
})

export const useUpdateRateCardMutation = makeAxiosMutation({
  serviceCall: RateCardsService.update,
  invalidates: () => [rateCardsBaseKey],
})

export const useDeleteRateCardMutation = makeAxiosMutation({
  serviceCall: RateCardsService.delete,
  invalidates: () => [rateCardsBaseKey],
})

export const useRestoreRateCardMutation = makeAxiosMutation({
  serviceCall: RateCardsService.restore,
  invalidates: () => [rateCardsBaseKey],
})
